import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  ActionsList,
  StyledOption,
  StyledLabel,
} from "./styles/candidate-actions-styles";

const sendMessage = { id: 0, value: "send_message", label: "Send Message" };
const telephoneInterviewRequested = {
  value: "telephone_interview_requested",
  label: "Request Phone Interview",
};
const firstInterviewRequested = {
  value: "first_interview_requested",
  label: "Request First Interview",
};
const secondInterviewRequested = {
  value: "second_interview_requested",
  label: "Request Second Interview",
};
const competenciesRequired = {
  value: "competencies_required",
  label: "Competencies Required",
};
const offeredJob = { value: "offered_job", label: "Make Offer" };
const rejectedCandidate = {
  value: "rejected_candidate",
  label: "Reject Candidate",
};

const defaultOptions = [
  sendMessage,
  telephoneInterviewRequested,
  firstInterviewRequested,
  secondInterviewRequested,
  competenciesRequired,
  offeredJob,
  rejectedCandidate,
];

const interviewOrCompetenciesRequestedOptions = [
  sendMessage,
  rejectedCandidate,
];

const firstInterviewConfirmedOptions = [
  sendMessage,
  firstInterviewRequested,
  secondInterviewRequested,
  competenciesRequired,
  offeredJob,
  rejectedCandidate,
];

const secondInterviewConfirmedOptions = [
  sendMessage,
  secondInterviewRequested,
  competenciesRequired,
  offeredJob,
  rejectedCandidate,
];

const competencyTestCompletedOptions = [
  sendMessage,
  telephoneInterviewRequested,
  firstInterviewRequested,
  secondInterviewRequested,
  competenciesRequired,
  offeredJob,
  rejectedCandidate,
];

const offerMadeOptions = [sendMessage, rejectedCandidate];

const sendMessageOption = [sendMessage];

const EmployerActionsList = ({
  actionsDropdown,
  offerMade,
  jobFilled,
  optionHandle,
  jobStatus,
}) => {
  let options = defaultOptions;

  switch (true) {
    case jobStatus === "Telephone Interview Requested":
    case jobStatus === "First Interview Requested":
    case jobStatus === "Second Interview Requested":
    case jobStatus === "Competencies Required":
      options = interviewOrCompetenciesRequestedOptions;
      break;
    case jobStatus === "Interview Declined":
      options = sendMessageOption;
      break;
    case jobStatus === "First Interview Confirmed":
      options = firstInterviewConfirmedOptions;
      break;
    case jobStatus === "Second Interview Confirmed":
      options = secondInterviewConfirmedOptions;
      break;
    case jobStatus === "Competency Test Completed":
      options = competencyTestCompletedOptions;
      break;
    case jobStatus === "Accepted Job":
      options = sendMessageOption;
      break;
    case !jobFilled && offerMade:
      options = offerMadeOptions;
      break;
    default:
      options = defaultOptions;
  }

  return (
    <ActionsList
      className={actionsDropdown ? "shown dropdown" : "dropdown"}
      id="actions-list"
    >
      {options.map((option) => (
        <Fragment key={option.value}>
          <StyledOption
            type="radio"
            name="option"
            id={option.value}
            data-testid={`${option.value}-option`}
          />
          <StyledLabel
            htmlFor={option.value}
            onClick={optionHandle}
            value={option.value}
          >
            {option.label}
          </StyledLabel>
        </Fragment>
      ))}
    </ActionsList>
  );
};

EmployerActionsList.propTypes = {
  actionsDropdown: PropTypes.bool.isRequired,
  optionHandle: PropTypes.func.isRequired,
  offerMade: PropTypes.bool.isRequired,
  jobFilled: PropTypes.bool,
  jobStatus: PropTypes.string.isRequired,
};

EmployerActionsList.defaultProps = {
  jobFilled: PropTypes.isNull,
};

export default EmployerActionsList;
